import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=be879dc8&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=ts&"
export * from "./Invoices.vue?vue&type=script&lang=ts&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=be879dc8&lang=scss&scoped=true&"
import style1 from "./Invoices.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be879dc8",
  null
  
)

export default component.exports